import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/adbazaar/v2/contract{/itemId}{/action}/`,
  {},
  {
    acceptContract: {
      method: 'POST',
      params: { action: 'accept' },
    },
    getStatus: {
      method: 'GET',
      params: { action: 'status' },
    },
  },
  {
    transformToCamelCase: true,
  },
);
